var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status && _vm.fileStatus
    ? _c(
        "p",
        { class: _vm.fileStatus.class },
        [
          _vm.shouldShowTooltip
            ? _c(
                "sc-tooltip",
                {
                  staticClass: "sc-order-importer-table__tooltip",
                  attrs: {
                    label: _vm.fileStatus.help,
                    type: "is-light",
                    position: "is-left",
                    dashed: ""
                  }
                },
                [
                  _c("sc-icon", {
                    staticClass: "sc-order-importer-table__tooltip__icon",
                    attrs: { icon: _vm.fileStatus.icon, size: "is-small" }
                  }),
                  _vm._v("\n    " + _vm._s(_vm.fileStatus.label) + "\n  ")
                ],
                1
              )
            : [
                _c("sc-icon", {
                  attrs: { icon: _vm.fileStatus.icon, size: "is-small" }
                }),
                _vm._v("\n    " + _vm._s(_vm.fileStatus.label) + "\n  ")
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f153fc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f153fc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-status-file-import/ScStatusFileImport.vue
// module id = null
// module chunks = 